import React from 'react';
import ReactDOM from 'react-dom/client';
// import './index.css';
import App from 'app';
import reportWebVitals from './reportWebVitals';
import { setupAxios } from 'shared/lib/axios';
import axios from 'axios';
import { QueryClient, QueryClientProvider } from 'react-query';

setupAxios(axios)

const queryClient = new QueryClient()

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
